export var THDSelectStyles = {
    root: {
        position: 'relative',
        width: '100%',
        '&:after': {
            '&$icon': { transform: 'rotate(180deg)' },
        },
    },
    select: {
        MozAppearance: 'none',
        WebkitAppearance: 'none',
        userSelect: 'none',
        paddingTop: '7px',
        paddingBottom: '6px',
        paddingRight: '4px',
        width: "calc(100% - 4px)",
        minWidth: '2px',
        cursor: 'pointer',
        '&:focus': {
            background: '#fff',
            borderRadius: 0,
            backgroundColor: '#fff',
        },
        '&:-moz-focusring': {
            color: 'transparent',
            textShadow: '0 0 0 #000',
        },
        '&::-ms-expend': {
            display: 'none',
        },
        '&$disabled': {
            cursor: 'default',
        },
    },
    filled: {},
    outlined: {},
    selectMenu: {
        width: '100%',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        minHeight: '1.1875em',
        '&.MuiSelect-select': {
            paddingRight: 40,
        },
    },
    disabled: {},
    icon: {
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#121111',
        width: '14px',
        right: '15px',
    },
    iconOpen: {
        transform: 'rotate(180deg) translateY(50%)',
    },
};
